import { createFileRoute } from '@tanstack/react-router'

import { OrganizationPage } from '#/modules/organizations/organization-page'

export const Route = createFileRoute('/_shell/organizations/$organizationId')({
  component: function OrganizationRoute() {
    const { organizationId } = Route.useParams()
    return <OrganizationPage organizationId={organizationId} />
  },
})
